import DatenshutzDialog from './container'
export { DatenshutzDialog }
export default DatenshutzDialog